module.exports = __webpack_public_path__ + "img/mail.16d9748e.png";